var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud',{attrs:{"title":"Questions","add":_vm.add,"remove":_vm.remove,"fetch":_vm.fetch,"default-entity":_vm.defaultEntity,"entity-summary":_vm.entitySummary}})}
var staticRenderFns = []

export { render, staticRenderFns }